var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceNotAvailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "538px",
    height: "331px",
    viewBox: "0 0 538 331",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ServiceNotAvailable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V4+ErrorsV2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Error_06-Copy",
    transform: "translate(-80.000000, -261.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ServiceNotAvailable",
    transform: "translate(80.000000, 261.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 536,
    height: 330
  }), /*#__PURE__*/React.createElement("g", {
    id: "MountainLightBlue",
    transform: "translate(348.000000, 235.500000) scale(-1, 1) translate(-348.000000, -235.500000) translate(160.000000, 141.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.777409, 76.453333)",
    stroke: "#DBDBDB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.610493,111.178255 C302.107058,99.815842 331.140486,92.3117535 344.710777,88.6659896 C356.191685,85.5815545 361.869483,83.1828451 362.796072,79.7286458 C363.512308,77.0586143 362.691477,73.3430692 351.363416,70.7913021 C330.271651,66.8966667 277.910404,61.6507812 264.640241,59.6667448 C251.370077,57.6827083 204.716698,54.433099 204.82171,40.4922135 C204.927077,26.5513281 239.797474,22.9382031 253.350692,20.8489062 C266.90391,18.7596094 270.425676,15.215026 270.425676,11.3889323 C270.425676,8.83820313 264.060185,5.49883681 251.329204,1.37083333",
    id: "Road2",
    transform: "translate(283.903397, 56.274544) scale(-1, 1) translate(-283.903397, -56.274544) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64353872,0.626666667 C16.6666779,2.77512153 25.6926093,4.84809896 28.7213328,6.84559896 C33.2644181,9.84184896 34.8496029,16.4475521 27.2111159,19.5551823 C22.1187913,21.6269358 15.9264593,23.6640104 8.63411999,25.6664063 C2.92615003,28.0702604 0.0721650488,30.6642361 0.0721650488,33.4483333 C0.0721650488,37.6244792 3.71797809,39.9438802 13.677978,41.5166667 C23.6379778,43.0894531 98.6027859,49.5605208 104.361312,49.8285677 C110.119838,50.0966146 204.177806,57.5346094 238.897756,67.0178385 C273.617707,76.5010677 288.298657,86.8569792 290.229123,94.8836979 C291.5161,100.234844 289.969359,104.632526 285.5889,108.076745",
    id: "Road1",
    transform: "translate(145.369832, 54.351706) scale(-1, 1) translate(-145.369832, -54.351706) "
  })), /*#__PURE__*/React.createElement("line", {
    x1: 0.208458783,
    y1: 77.08,
    x2: 302.014924,
    y2: 77.08,
    id: "MountianHorizonLine",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine4",
    stroke: "#D4D4D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "49.0996678 76.4533333 141.157807 0 213.802326 56.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "MountainLine1",
    stroke: "#D4D4D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "193.136213 38.7823899 213.802326 20.0533333 283.315615 75.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.059985,49.031331 L292.667306,70.7252083 L292.667306,70.7252083 L285.247516,76.4556341 L279.066439,76.9125562 L286.112203,48.9943768 C286.247347,48.4588821 286.791007,48.1343336 287.326502,48.2694774 C287.696264,48.362795 287.98076,48.6582954 288.059985,49.031331 Z",
    id: "MountainTree1",
    fill: "#DBDBDB",
    transform: "translate(285.866872, 63.006956) scale(-1, 1) translate(-285.866872, -63.006956) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stump",
    transform: "translate(56.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StumpLightBlue",
    transform: "translate(31.481481, 0.000000)",
    fill: "#E5E9E9",
    stroke: "#B0B1B1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8518519,152.396912 L30.8518519,6.27071823 L9.44444444,0 L9.44444444,210.284617 C9.42886066,212.703574 8.65561359,215.088838 7.55555556,217.440408 C6.45549752,219.791978 3.66084336,222.769485 0,225.118785 L40.2962963,225.118785 C36.7556947,222.85384 34.8212877,220.224111 33.3703704,218.483742 C31.919453,216.743372 31.1254649,214.389187 30.8518519,211.421184 L30.8518519,173.532638 C31.1351144,173.347411 30.7741176,173.130782 31.0231602,172.882752 L57.736083,146.278347 C59.7031683,144.319253 59.7031683,141.142934 57.736083,139.183839 L54.17436,135.636585 C52.2072747,133.677491 49.0179992,133.677491 47.0509139,135.636585 L30.8518519,152.396912 Z",
    id: "Stump"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpWhite",
    transform: "translate(40.296296, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "StumpHighlight",
    points: "1.97404876 0.789351152 21.341616 7.14365855 21.341616 11.3298529 0.214590567 5.17456729"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StumpDarkBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3333333,152.396912 L62.3333333,6.27071823 L40.9259259,0 L40.9259259,210.284617 C40.9103421,212.703574 40.1370951,215.088838 39.037037,217.440408 C37.936979,219.791978 35.1423248,222.769485 31.4814815,225.118785 L71.7777778,225.118785 C68.2371762,222.85384 66.3027692,220.224111 64.8518519,218.483742 C63.4009345,216.743372 62.6069464,214.389187 62.3333333,211.421184 L62.3333333,173.532638 C62.6165959,173.347411 62.2555991,173.130782 62.5046417,172.882752 L89.2175645,146.278347 C91.1846498,144.319253 91.1846498,141.142934 89.2175645,139.183839 L85.6558415,135.636585 C83.6887561,133.677491 80.4994807,133.677491 78.5323954,135.636585 L62.3333333,152.396912 Z",
    id: "StumpOutline",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.3333333,
    y1: 225.118785,
    x2: 102,
    y2: 225.118785,
    id: "StumpHorizonLine2",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 225.118785,
    x2: 3.77777778,
    y2: 225.118785,
    id: "StumpHorizonLine1",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.75982,209.939025 L75.5555556,224.491713 L75.5555556,224.491713 L68,224.491713 L70.7957356,209.939025 C70.8999304,209.396658 71.4240722,209.041449 71.9664392,209.145644 C72.3683262,209.222851 72.682613,209.537138 72.75982,209.939025 Z",
    id: "Grass3",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7831295,213.598302 L80.5925926,224.491713 L80.5925926,224.491713 L73.037037,224.491713 L75.8465001,213.598302 C75.9844238,213.063517 76.5297624,212.741797 77.0645478,212.87972 C77.4170018,212.97062 77.69223,213.245848 77.7831295,213.598302 Z",
    id: "Grass2",
    fill: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6720184,213.598302 L31.4814815,224.491713 L31.4814815,224.491713 L23.9259259,224.491713 L26.735389,213.598302 C26.8733127,213.063517 27.4186513,212.741797 27.9534367,212.87972 C28.3058907,212.97062 28.5811189,213.245848 28.6720184,213.598302 Z",
    id: "Grass1",
    fill: "#D4D4D4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sign",
    transform: "translate(8.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SignLightBlue",
    fill: "#E5E9E9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L191.745223,0 C193.954362,-1.61026889e-14 195.745223,1.790861 195.745223,4 L195.745223,115.752577 C195.745223,117.961716 193.954362,119.752577 191.745223,119.752577 L4,119.752577 C1.790861,119.752577 2.705415e-16,117.961716 0,115.752577 L0,94.7237234 L0,94.7237234 L7.52866242,91.8110402 L0,89.6767779 L0,83.8562842 L12.5477707,79.7193239 L0,73.8635027 L0,4 C-7.1463071e-16,1.790861 1.790861,-3.82769592e-17 4,0 Z",
    id: "Rectangle-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SignDarkBlue"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.627388535 0.62371134 196.372611 0.62371134 196.372611 120.376289 0.627388535 120.376289 0.627388535 95.3474348 8.15605096 92.4347515 0.627388535 90.3004893 0.627388535 84.4799956 13.1751592 80.3430352 0.627388535 74.4872141"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.490446,
    y1: 40.5412371,
    x2: 0,
    y2: 40.5412371,
    id: "SignLine2",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.490446,
    y1: 80.4587629,
    x2: 11.2929936,
    y2: 80.4587629,
    id: "SignLine1",
    stroke: "#B0B1B1",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Nail4",
    fill: "#6D6D6D",
    cx: 183.197452,
    cy: 12.4742268,
    rx: 3.76433121,
    ry: 3.74226804
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Nail3",
    fill: "#6D6D6D",
    cx: 183.197452,
    cy: 107.278351,
    rx: 3.76433121,
    ry: 3.74226804
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Nail2",
    fill: "#6D6D6D",
    cx: 12.5477707,
    cy: 12.4742268,
    rx: 3.76433121,
    ry: 3.74226804
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Nail1",
    fill: "#6D6D6D",
    cx: 12.5477707,
    cy: 107.278351,
    rx: 3.76433121,
    ry: 3.74226804
  })), /*#__PURE__*/React.createElement("g", {
    id: "SignWhite",
    transform: "translate(2.509554, 2.494845)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0971627,41.0842453 C67.0301321,45.7739339 65.2484076,51.3708361 65.2484076,57.3814433 C65.2484076,73.9158238 78.7311956,87.3195876 95.3630573,87.3195876 C101.409101,87.3195876 107.039001,85.5483061 111.756338,82.4992516 L70.0971627,41.0842453 L70.0971627,41.0842453 Z M78.9697765,32.263635 L120.628952,73.6786413 C123.695983,68.9889527 125.477707,63.3920505 125.477707,57.3814433 C125.477707,40.8470627 111.994919,27.443299 95.3630573,27.443299 C89.3170136,27.443299 83.6871139,29.2145805 78.9697765,32.263635 L78.9697765,32.263635 Z M95.3630573,99.7938144 C71.8012532,99.7938144 52.7006369,80.8051491 52.7006369,57.3814433 C52.7006369,33.9577375 71.8012532,14.9690722 95.3630573,14.9690722 C118.924861,14.9690722 138.025478,33.9577375 138.025478,57.3814433 C138.025478,80.8051491 118.924861,99.7938144 95.3630573,99.7938144 Z",
    id: "NoNo"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SignHighlight",
    x: 0,
    y: 0,
    width: 191.980892,
    height: 3.74226804
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Balloon2",
    transform: "translate(480.000000, 6.000000)",
    stroke: "#B0B1B1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Balloon2DarkBlue"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "BalloonOval2",
    fill: "#D4D4D4",
    cx: 25.5,
    cy: 25.8863636,
    rx: 25.119403,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "BalloonOval1",
    fill: "#E5E9E9",
    cx: 25.6902985,
    cy: 25.8863636,
    rx: 14.6529851,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BalloonBasket",
    fill: "#E5E9E9",
    x: 18.6492537,
    y: 59.5,
    width: 13.7014925,
    height: 8.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.4850746,
    y1: 59.5,
    x2: 31.5895522,
    y2: 45.5909091,
    id: "BalloonString4",
    transform: "translate(36.537313, 52.545455) scale(-1, 1) translate(-36.537313, -52.545455) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.4477612,
    y1: 59.5,
    x2: 27.7835821,
    y2: 51,
    id: "BalloonString3",
    transform: "translate(29.115672, 55.250000) scale(-1, 1) translate(-29.115672, -55.250000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.2164179,
    y1: 59.5,
    x2: 20.5522388,
    y2: 51,
    id: "BalloonString2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.4104478,
    y1: 59.5,
    x2: 9.13432836,
    y2: 45.5909091,
    id: "BalloonString1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree2",
    transform: "translate(406.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree2White",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4192408,0.702224979 L42.2488135,64.9374035 C42.559527,65.997371 41.9521366,67.1085273 40.8921692,67.4192408 C40.7094378,67.4728057 40.5199932,67.5 40.3295727,67.5 L2.67042725,67.5 C1.56585775,67.5 0.670427255,66.6045695 0.670427255,65.5 C0.670427255,65.3095795 0.697621521,65.1201349 0.751186461,64.9374035 L19.5807592,0.702224979 C19.8914727,-0.357742442 21.002629,-0.965132799 22.0625965,-0.654419353 C22.716356,-0.462779604 23.227601,0.0484654023 23.4192408,0.702224979 Z",
    id: "Tree2WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree2LightBlue",
    fill: "#DBDBDB",
    stroke: "#B0B1B1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree2LightBlueOutline1",
    points: "21.5 0.404929577 43 67.5 -2.29824003e-12 67.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,5.86914062 C21.5,53.8070368 21.5,78.3089899 21.5,79.375 C21.5,78.3089899 21.5,53.8070368 21.5,5.86914062 Z",
    id: "Tree2LightBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,36.6549296 C28.245098,44.7314514 31.6176471,48.8981181 31.6176471,49.1549296 C31.6176471,48.8981181 28.245098,44.7314514 21.5,36.6549296 Z",
    id: "Tree2LightBlueLine1",
    transform: "translate(26.558824, 42.904930) scale(-1, 1) translate(-26.558824, -42.904930) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Tree1",
    transform: "translate(440.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree1White",
    transform: "translate(1.245283, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9388786,0 L63.5489796,105.954 C63.864761,107.012469 63.262694,108.126519 62.2042253,108.4423 C62.0186799,108.497655 61.8260793,108.525773 61.6324525,108.525773 L2.24530456,108.525773 C1.14073506,108.525773 0.245304563,107.630343 0.245304563,106.525773 C0.245304563,106.332146 0.273422276,106.139546 0.328777525,105.954 L31.9388786,0 L31.9388786,0 Z",
    id: "Tree1WhiteBkgd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tree1LightBlue",
    fill: "#E5E9E9",
    stroke: "#B0B1B1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Tree1LightBlueOutine",
    points: "33 0 65.3773585 108.525773 0.622641509 108.525773"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,4.47378886 C33,79.8676135 33,118.50178 33,120.376289 C33,118.50178 33,79.8676135 33,4.47378886 Z",
    id: "Tree1LightBlueLine3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7313314,46.1546392 C28.2030295,51.6582997 31.9388786,54.5689526 31.9388786,54.8865979 C31.9388786,54.5689526 28.2030295,51.6582997 20.7313314,46.1546392 Z",
    id: "Tree1LightBlueLine2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4294446,84.8247423 C46.0520861,71.201255 51.8634069,64.5483341 51.8634069,64.8659794 C51.8634069,64.5483341 46.0520861,71.201255 34.4294446,84.8247423 Z",
    id: "Tree1LightBlueLine1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud2",
    transform: "translate(110.000000, 17.000000)",
    stroke: "#E5E9E9",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud2LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1929825,20.7682927 L79.0263158,20.7682927 C78.1218676,14.0168842 80.3829881,8.36891119 85.8096774,3.82437357 C92.0411827,-1.24325338 99.4394874,-0.10715987 103.41273,1.64147056 C107.385973,3.39010099 110.336659,5.79256979 112.38208,10.3260308 C113.248758,12.2347924 113.837772,13.8496927 114.149123,15.1707317",
    id: "Cloud2Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.114035,24.5 C105.438449,19.9550186 108.156592,16.9834401 112.268463,15.5852646 C118.436269,13.4880014 124.284659,16.2810118 126.620708,19.0913324 C128.956757,21.901653 129.697261,24.1592631 130.138256,26.5152677 C130.432253,28.0859375 130.538214,29.9019865 130.45614,31.9634146 C135.651511,31.7536681 139.135168,32.7902534 140.907111,35.0731707 C143.050224,37.8017995 143.270109,41.0658286 142.489487,43.4695122 C141.708864,45.8731957 139.104544,49.3780488 134.219298,49.3780488 L35.122807,49.3780488",
    id: "Cloud2Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5789474,
    y1: 33.2073171,
    x2: 104.11466,
    y2: 33.2073171,
    id: "Cloud2Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 33.2073171,
    x2: 10.0350877,
    y2: 33.2073171,
    id: "Cloud2Outline1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    transform: "translate(290.000000, 73.000000)",
    stroke: "#DBDBDB",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud1LightBlue"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1929825,20.7682927 L79.0263158,20.7682927 C78.1218676,14.0168842 80.3829881,8.36891119 85.8096774,3.82437357 C92.0411827,-1.24325338 99.4394874,-0.10715987 103.41273,1.64147056 C107.385973,3.39010099 110.336659,5.79256979 112.38208,10.3260308 C113.248758,12.2347924 113.837772,13.8496927 114.149123,15.1707317",
    id: "Cloud1Outline4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.114035,24.5 C105.438449,19.9550186 108.156592,16.9834401 112.268463,15.5852646 C118.436269,13.4880014 124.284659,16.2810118 126.620708,19.0913324 C128.956757,21.901653 129.697261,24.1592631 130.138256,26.5152677 C130.432253,28.0859375 130.538214,29.9019865 130.45614,31.9634146 C135.651511,31.7536681 139.135168,32.7902534 140.907111,35.0731707 C143.050224,37.8017995 143.270109,41.0658286 142.489487,43.4695122 C141.708864,45.8731957 139.104544,49.3780488 134.219298,49.3780488 L35.122807,49.3780488",
    id: "Cloud1Outline3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5789474,
    y1: 33.2073171,
    x2: 104.11466,
    y2: 33.2073171,
    id: "Cloud1Outline2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 33.2073171,
    x2: 10.0350877,
    y2: 33.2073171,
    id: "Cloud1Outline1"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceNotAvailable);
export default __webpack_public_path__ + "static/media/serviceNotAvailable.6fce13fc3bb125577ae17cd0cb100cb1.svg";
export { ForwardRef as ReactComponent };